<template>
  <popup :close-action="closeActionClicked" :buttons="buttons" class="savings-challenge-popup">
    <template v-slot:title>
      <div class="title-image">
        <img :src="require('@/assets/challenges/savings.svg')">
      </div>
      <div class="title-text">אתגר <span class="bold">חיסכון זה ביטחון</span> של riseup יצא לדרך!</div>
    </template>
    <template v-slot:content>
      <div class="savings-challenge-content">
        <div>כולנו רוצים לחסוך בצורה נכונה כל חודש, ועם הכוח של הקהילה שלנו נוכל ללמוד לעשות את זה!</div>
        <div>יוסי ואתי מובילים את האתגר החודש, בואו תצטרפו אליהם ולכל קהילת הלקוחות שלנו שעושים את זה יחד 🙂</div>
        <div>יש שם המון מידע, ואפשר לשאול הכל!</div>
      </div>
    </template>
  </popup>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../Segment';

export default {
  name: 'SavingsChallengeCommunityPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  async created() {
    Segment.trackUserInteraction('SavingsChallengeCommunityPopupShown');
  },
  computed: {
    buttons() {
      return [{
        title: 'קחו אותי לקהילה!',
        action: this.openFacebook,
        variant: 'primary',
      }];
    },
  },
  methods: {
    ...mapActions('savingsChallenge', ['setPopupClosed']),
    closeActionClicked() {
      Segment.trackUserInteraction('SavingsChallengeCommunityPopup_CloseButtonClicked');
      this.setPopupClosed();
      this.$emit('close');
    },
    openFacebook() {
      Segment.trackUserInteraction('SavingsChallengeCommunityPopup_TellMeMoreClicked');
      window.open('https://www.facebook.com/groups/riseuptogethergroup', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">

.savings-challenge-popup .title {}

.savings-challenge-popup {
  .title-text {
    text-align: center;
    font-family: SimplerPro;
    line-height: 1.1;
    font-size: 27px;

    .bold {
      font-weight: bold;
    }
  }


  .title-image {
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 26px;
    }
  }

  .savings-challenge-content {
    line-height: 1.5;
    text-align: center;
    font-family: SimplerPro;

    div {
      margin-bottom: 20px;
    }

    div:last-child {
      margin-bottom: 0;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/challenges/SavingsChallengeCommunityPopup.vue